<template>
    <div class="full flex wrap center">
        <div class="full excel flex wrap center vcenter">
            <button @click.prevent="download('ReportAsExcel')">برون بری با فرمت اکسل</button>
        </div>
        <div class="full pdf flex wrap center vcenter">
            <button @click.prevent="">برون بری با فرمت پی دی اف</button>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
export default {
    name: 'Export',
    props: ['data'],
    inject: ['base'],
    components: {},
    data() {
        return {

        }
    },
    methods: {
        download(format) {
            this.$emit('onloading', true)
            this.base.API().postAsArrayBuffer(`Data/Report/${format}`, {
                data: Object.assign(Object.assign(this.$route.query, {
                    entity_type: this.data?.entity_type.toUpperCase(),
                    search: this.data?.search
                }), this.data?.query)
            }, (response) => {
                this.$emit('onloading', false)
                const link = document.createElement('a')
                link.href = window.URL.createObjectURL(new Blob([response.data]))
                link.setAttribute('download', `report-${Date.now()}.${format === 'ReportAsExcel' ? 'xlsx' : 'pdf'}`)
                document.body.appendChild(link)
                link.click()

                this.$emit('onresult')
            }, (error) => {
                this.$emit('onloading', false)
            })
        }
    }
}
</script>

<style src="../../assets/css/components/dialogs/export.css"></style>